/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Results_To_DisplayInputs */



/**
* | output |
* | --- |
* | "No results to display" |
*
* @param {No_Results_To_DisplayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_results_to_display = /** @type {((inputs?: No_Results_To_DisplayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Results_To_DisplayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun résultat à afficher")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Ergebnisse verfügbar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun risultato da visualizzare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты отсутствуют.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay resultados para mostrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无结果显示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("表示する結果がありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दिखाने के लिए कोई परिणाम नहीं हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum resultado para exibir.")
	return /** @type {LocalizedString} */ ("No results to display")
});